import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Row, Col, Typography, Button, Input, Table, Spin, Icon } from 'antd'

const { Text } = Typography

@inject('orderSetupStore')
@observer
class OrderRecommendationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    // TABLE Settings

    orderItemColumns = () => {
        return [
            {
                title: 'Category',
                key: 'orderRecommendationCategoryTaskName',
                dataIndex: 'orderRecommendationCategoryTaskName',
                width: '25%',
            },
            {
                title: 'Sub-Category',
                key: 'orderRecommendationSubCategoryTaskName',
                dataIndex: 'orderRecommendationSubCategoryTaskName',
                width: '25%',
                ...this.tableSearchProperties('orderRecommendationSubCategoryTaskName'),
                render: orderRecommendationSubCategoryTaskName => (
                    <span>{orderRecommendationSubCategoryTaskName === '' ? '--' : orderRecommendationSubCategoryTaskName}</span>
                )
            },
            {
                title: 'Item',
                key: 'orderRecommendationTaskName',
                dataIndex: 'orderRecommendationTaskName',
                width: '40%',
                ...this.tableSearchProperties('orderRecommendationTaskName')
            },
            {
                title: 'Action',
                dataIndex: 'itemId',
                key: 'action',
                width: '10%',
                render: (data, record) => {
                    if (record.selected) {
                        return (
                            <span>
                                <Button className='ordersetup-button-modal-unselect' onClick={() => this.deleteOrderRecommendationSetupClicked(record.orderSetupId, record.orderRecommendationSetupId)}>
                                    Unselect
                                </Button>
                            </span>
                        )
                    } else {
                        return (
                            <span>
                                <Button onClick={() => this.createOrderRecommendationSetupClicked(record.orderSetupId, record.orderRecommendationCategoryTaskId, record.orderRecommendationSubCategoryTaskId, record.orderRecommendationTaskId)} type='primary'>
                                    Select
                                </Button>
                            </span>
                        )
                    }
                }
            },
        ]
    }

    orderCategoryColumns = () => {
        return [
            {
                title: 'Category',
                key: 'orderRecommendationCategoryTaskName',
                dataIndex: 'orderRecommendationCategoryTaskName',
                width: '25%',
            },
            {
                title: 'Sub-Category',
                key: 'orderRecommendationSubCategoryTaskName',
                dataIndex: 'orderRecommendationSubCategoryTaskName',
                width: '25%',
                ...this.tableSearchProperties('orderRecommendationSubCategoryTaskName')
            },
            {
                title: 'Action',
                dataIndex: 'itemId',
                key: 'action',
                width: '10%',
                render: (data, record) => {
                    if (record.selected) {
                        return (
                            <span>
                                <Button className='ordersetup-button-modal-unselect' onClick={() => this.deleteOrderRecommendationSetupClicked(record.orderSetupId, record.orderRecommendationSetupId)}>
                                    Unselect
                                </Button>
                            </span>
                        )
                    } else {
                        return (
                            <span>
                                <Button onClick={() => this.createOrderRecommendationSetupClicked(record.orderSetupId, record.orderRecommendationCategoryTaskId, record.orderRecommendationSubCategoryTaskId, 0)} type='primary'>
                                    Select
                                </Button>
                            </span>
                        )
                    }
                }
            },
        ]
    }

    tableSearchProperties = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.tableSearchClicked(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.tableSearchClicked(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.tableResetClicked(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        }
    })

    tableSearchClicked = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        })
    }

    tableResetClicked = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    // CLICKED Action

    createOrderRecommendationSetupClicked = (orderSetupId, orderRecommendationCategoryTaskId, orderRecommendationSubCategoryTaskId, orderRecommendationTaskId) => {
        this.props.orderSetupStore.createOrderRecommendationSetup(orderSetupId, orderRecommendationCategoryTaskId, orderRecommendationSubCategoryTaskId, orderRecommendationTaskId)
    }

    deleteOrderRecommendationSetupClicked = (orderSetupId, orderRecommendationSetupId) => {
        this.props.orderSetupStore.deleteOrderRecommendationSetupFromModal(orderSetupId, orderRecommendationSetupId)
    }

    orderRecommendationModalTabClicked = (tabName) => {
        this.props.orderSetupStore.setOrderRecommendationModalTab(tabName)
    }

    render() {
        const {
            orderRecommendationItemDataSources,
            orderRecommendationCategoryDataSources,
            spinningOrderRecommendationModal,
            orderRecommendationModalTab
        } = this.props.orderSetupStore

        return (
            <Spin spinning={spinningOrderRecommendationModal}>
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col span={24} className='ordersetup-col-modal-tabs'>
                                <Row>
                                    <Col span={6} />
                                    {orderRecommendationModalTab === 'item' ?
                                        <Col span={6} className='ordersetup-col-modal-tab-left-selected'>
                                            <Text className='ordersetup-text-modal-tab-left-selected'>Add Item</Text>
                                        </Col>
                                        :
                                        <Col span={6} className='ordersetup-col-modal-tab-left' onClick={() => this.orderRecommendationModalTabClicked('item')}>
                                            <Text className='ordersetup-text-modal-tab-left'>Add Item</Text>
                                        </Col>
                                    }
                                    {orderRecommendationModalTab === 'category' ?
                                        <Col span={6} className='ordersetup-col-modal-tab-right-selected'>
                                            <Text className='ordersetup-text-modal-tab-right-selected'>Add Category</Text>
                                        </Col>
                                        :
                                        <Col span={6} className='ordersetup-col-modal-tab-right' onClick={() => this.orderRecommendationModalTabClicked('category')}>
                                            <Text className='ordersetup-text-modal-tab-right'>Add Category</Text>
                                        </Col>
                                    }
                                    <Col span={6} />
                                </Row>
                            </Col>
                            <Col span={24}>
                                {orderRecommendationModalTab === 'item' ?
                                    <Table columns={this.orderItemColumns()} dataSource={orderRecommendationItemDataSources} />
                                    :
                                    <Table columns={this.orderCategoryColumns()} dataSource={orderRecommendationCategoryDataSources} />
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Spin>
        )
    }
}

export default OrderRecommendationModal